import { PlasterService } from './../plaster.service';
import { ProjectService } from './../project.service';
import { Component, OnInit } from '@angular/core';
import { Project } from '../project';
import { Plaster } from '../plaster';
import { KnaufPlaster } from '../knauf-plaster.enum';
import { Calculator } from '../calculator';
import { Router } from '@angular/router';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.sass']
})
export class CalculatorComponent implements OnInit {
  title: string = "KALKULATOR ZUŻYCIA TYNKU";
  subtitle: string = "Oblicz, ile opakowań tynku potrzebujesz do wykończenia elewacji";
  next: string = "/where-buy";
  prev: string = "/questionnaire-summary";
  KnaufPlaster = KnaufPlaster;
  selectedPlaster = 3;
  selectedMosaic = 0;
  plasterBucket: number = 0;
  mosaicBucket: number = 0;
  plasterMeters: string = '';
  mosaicMeters: string = '';
  project: Project;
  plaster: Plaster;
  mosaicOption: number = 0;
  mosaicTab: boolean = false;

  constructor(private projectService: ProjectService, private plasterService: PlasterService, private router: Router, private modalService: ModalService) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.plaster = this.plasterService.getKnaufPlaster(this.projectService.getSelectedKnaufPlaster());
    this.selectedMosaic = this.project.calculator.mosaic.gramatura;
    this.mosaicMeters = String(this.project.calculator.mosaic.meters);
    if (this.mosaicMeters == '0') this.mosaicMeters = '';
    this.selectedPlaster = this.project.calculator.plaster.gramatura;
    this.plasterMeters = String(this.project.calculator.plaster.meters);
    if (this.plasterMeters == '0') this.plasterMeters = '';
    this.countPlasterBucket();
    this.countMosaicBucket();
    if (this.project.selectedMosaic && this.project.selectedMosaic.code < "B37") {
      this.selectedMosaic = 1;
    } else {
      this.selectedMosaic = 2;
    }
  }

  onSelectPlaster(choise) {
    this.selectedPlaster = choise;
    this.countPlasterBucket();
  }

  onSelectMosaic(choise) {
    this.selectedMosaic = choise;
    this.countMosaicBucket();
  }

  onPlasterChange(event) {
    this.plasterMeters = event.target.value;
    this.countPlasterBucket();
  }

  onMosaicChange(event) {
    this.mosaicMeters = event.target.value;
    this.countMosaicBucket();
  }

  countPlasterBucket() {
    let buckets = Calculator.calculatePlasterBuckets(this.plaster.knaufPlaster, Number(this.plasterMeters.replace(',', '.')), this.selectedPlaster);
    this.projectService.setCalculatorPlaster(this.plasterMeters, this.selectedPlaster, buckets);
    this.plasterBucket = buckets;
  }

  countMosaicBucket() {
    let buckets = Calculator.calculateMosaicBuckets(Number(this.mosaicMeters.replace(',','.')), this.selectedMosaic);
    this.projectService.setCalculatorMosaic(this.mosaicMeters, this.selectedMosaic, buckets);
    this.mosaicBucket = buckets;
  }

  selectPlaster() {
    this.mosaicTab = false;
  }

  selectMosaic() {
    this.mosaicTab = true;
  }

  closeModal() {
    this.modalService.close('confirmation-dlg');
  }

  accept() {
    this.closeModal();
    this.router.navigate([this.next])
  }

  onNextClick(event: string) {
    this.modalService.open('confirmation-dlg');
  }
}
